export interface IPNSPasswordReset {
  token: string;
  resetCode: string;
  password: string;
}
